import { Navigate, Route, Routes } from 'react-router-dom'
import McVerificationReview from './McVerificationReview'

export default function McVerificationRoutes() {
    return (
        <Routes>
            <Route index element={<McVerificationReview />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
